import { render, staticRenderFns } from "./OrderDeliveryDateField.vue?vue&type=template&id=2e50a11f&"
import script from "./OrderDeliveryDateField.vue?vue&type=script&lang=js&"
export * from "./OrderDeliveryDateField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e50a11f')) {
      api.createRecord('2e50a11f', component.options)
    } else {
      api.reload('2e50a11f', component.options)
    }
    module.hot.accept("./OrderDeliveryDateField.vue?vue&type=template&id=2e50a11f&", function () {
      api.rerender('2e50a11f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/orders/fields/OrderDeliveryDateField.vue"
export default component.exports